export const contentTypes = {
  ICON_CHECK: 'icon-check',
  ICON_MINUS: 'icon-minus',
  TEXT: 'text',
};
